import axios from '../utils/axios'

function request(functionId, body) {
  let data = {
    functionId,
    body,
  }
  return axios.request({
    data: data,
    method: 'post'
  })
}
export function listTenantContentLabels(body) {
  return request("health_cmp_biz_pageAuditLabels", body);
}
export function healthCmpQueryBodyParts(body) {
  return request('health_cmp_queryBodyParts', body);
}

// 症状名模糊查询
export function getsSymptomsName(body) {
  return request('fuzzyQueryBySymptomName', body);
}

// 写手端获取草稿列表
export function getUserDraft(body) {
  return request('health_cmp_queryUserContentDrafts', body);
}

// 获取疾病、症状百科列表数据
export function getDiseaseSymptoms(body) {
  return request('health_cmp_queryContentDrafts', body);
}

// 获取疾病、症状百科审核状态
export function getReviewStatus(body) {
  return request('health_cmp_queryContentDraftCountList', body);
}

// 新增修改疾病、症状百科文章
export function newDiseaseSymptoms(body) {
  return request('health_cmp_saveOrUpdateContentDraft', body);
}

// 获取疾病、症状百科内容草稿详情
export function getDiseaseSymptomsDraftDetails(body) {
  return request('health_cmp_queryContentDraftById', body);
}

// 获取疾病、症状百科内容详情
export function getDiseaseSymptomsDetails(body) {
  return request('health_cmp_queryContentById', body);
}

// 更改疾病、症状审核状态
export function changgeDiseaseSymptomsState(body) {
  return request('health_cmp_updateContentAuditStatus', body);
}

// 更改疾病、症状上下线状态
export function changgeDiseaseSymptomsOnline(body) {
  return request('health_cmp_updateContentStatus', body);
}

// 获取疾病、症状段落
export function getDiseaseSymptomsParagraph(body) {
  return request('health_cmp_getContentParagraphDictionary', body);
}

// 获取疾病、症状驳回理由
export function getDiseaseSymptomsRejected(body) {
  return request('health_cmp_queryAuditReason', body);
}

// 获取疾病、症状预览信息
export function getDiseaseSymptomsPreview(body) {
  return request('health_cmp_queryContentPreviewInfo', body);
}

// 查看疾病、症状线上信息
export function seeDiseaseSymptomsOnline(body) {
  return request('health_cmp_onlineViewContent', body);
}

// 驳回疾病、症状文章
export function rejectedDiseaseSymptoms(body) {
  return request('health_cmp_manRejectContent', body);
}

// 审核通过疾病、症状文章
export function auditDiseaseSymptoms(body) {
  return request('health_cmp_manPassContent', body);
}

// 获取疾病信息列表
export function getDiseaseInformation(body) {
  return request('health_cmp_pageDiseaseInfoByParam', body);
}

// 获取医生信息列表
export function getDoctorInformation(body) {
  return request('health_cmp_listByDoctorName', body);
}

// 获取症状信息列表
export function getSymptomsInformation(body) {
  return request('health_cmp_pageByName', body);
}

// 获取内容疾病信息
export function getContentDisease(body) {
  return request('health_cmp_queryContents', body);
}

// 写手端文章提交
export function submittedByWriter(body) {
  return request('health_cmp_publishContent', body);
}

// 运营端提交
export function operationSubmission(body) {
  return request('health_cmp_manPublishContent', body);
}

// 撤销投稿
export function withdrawalContribution(body) {
  return request('health_cmp_cancelApplyContent', body);
}

// 运营端更新内容
export function manToUpdate(body) {
  return request('health_cmp_manUpdateContentDraft', body);
}

// 查询科室信息关联文章
export function queryDepartmentAssociation(body) {
  return request('health_cmp_queryDepartsWithContentRel', body);
}
